import React from "react";
import List from "../components/List";
import hipladeTemplate from "../../common/template";

function CompetenceList() {
  return <List />;
}

export default hipladeTemplate(CompetenceList);
